import { merge } from "remeda";
import { CONTRACTS, CONTRACT_DETAIL } from "../actionTypes";
import { Resource } from "ghost-stories/dist/unions/Resource";

const initial = {
  list: Resource.Empty({
    tipoConsulta: "",
    nro: "",
  }),
  detail: Resource.Empty({
    nro: "",
    tipoConsulta: "",
  }),
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initial, action) => {
  switch (action.type) {
    case CONTRACTS:
      return merge(state, { list: action.payload });
    case CONTRACT_DETAIL:
      return merge(state, { detail: action.payload });
    default:
      return state;
  }
};
